var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("basic-container", [
        _c("div", { staticClass: "page-container entity-present-log-page" }, [
          _c(
            "div",
            { staticClass: "query-form-wrap" },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: true, model: _vm.form, size: _vm.formSize },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "range-separator": "至",
                          "start-placeholder": "领取开始日期",
                          "end-placeholder": "领取结束日期",
                        },
                        on: { change: _vm.handleTimeChange },
                        model: {
                          value: _vm.timeSpan,
                          callback: function ($$v) {
                            _vm.timeSpan = $$v
                          },
                          expression: "timeSpan",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          clearable: "",
                          placeholder: "用户账号/收货人/电话查询",
                        },
                        model: {
                          value: _vm.form.keyword,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "keyword", $$v)
                          },
                          expression: "form.keyword",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "订单编号查询" },
                        model: {
                          value: _vm.form.orderId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "orderId", $$v)
                          },
                          expression: "form.orderId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: {
                            placeholder: "请选择赠品名称",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.giftName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "giftName", $$v)
                            },
                            expression: "form.giftName",
                          },
                        },
                        _vm._l(_vm.giftTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.giftName,
                              value: item.giftName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "活动名称" },
                        model: {
                          value: _vm.form.activityName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "activityName", $$v)
                          },
                          expression: "form.activityName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value:
                                "RUNACTIVITYMANAGE_ENTITYPRESENTLOG_SEARCH",
                              expression:
                                "'RUNACTIVITYMANAGE_ENTITYPRESENTLOG_SEARCH'",
                            },
                          ],
                          attrs: {
                            loading: _vm.listLoading,
                            icon: "el-icon-search",
                            type: "primary",
                          },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value:
                                "RUNACTIVITYMANAGE_ENTITYPRESENTLOG_EXPORT",
                              expression:
                                "'RUNACTIVITYMANAGE_ENTITYPRESENTLOG_EXPORT'",
                            },
                          ],
                          attrs: {
                            type: "warning",
                            plain: "",
                            icon: "el-icon-download",
                          },
                          on: { click: _vm.handleExport },
                        },
                        [_vm._v("导出")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table-wrap" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "eltable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.giftRecords,
                    height: _vm.autoTableHeight,
                    border: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      "header-align": "center",
                      align: "center",
                      label: "序号",
                      width: "50",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderNum",
                      align: "center",
                      "header-align": "center",
                      label: "订单号",
                      width: "250",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userAccount",
                      align: "center",
                      label: "用户账号",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "收货人", width: "180" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "mobile",
                      align: "center",
                      label: "收货人电话",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "address", label: "地址", width: "200" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "giftName",
                      "header-align": "center",
                      align: "center",
                      label: "赠品",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "promotionName",
                      "header-align": "center",
                      align: "center",
                      label: "活动",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      width: "200",
                      "header-align": "center",
                      align: "center",
                      label: "领取时间",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table-pagination" },
            [
              _c("TablePagination", {
                attrs: {
                  "page-size": _vm.pageConfig.size,
                  total: _vm.total,
                  "current-page": _vm.pageConfig.current,
                },
                on: {
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.pageConfig, "size", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.pageConfig, "size", $event)
                  },
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.pageConfig, "current", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.pageConfig, "current", $event)
                  },
                  change: _vm.handlePageChange,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }